import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import DescriptionIcon from "@material-ui/icons/Description";
import EditIcon from "@material-ui/icons/Edit";
import ArrivedIcon from "@material-ui/icons/LocalShipping";
import SubjectIcon from "@material-ui/icons/Subject";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { CustomFieldDatagridWrapper } from "components/CustomFields/CustomFieldWrapper";
import { ToggleDatesEnum } from "components/filters/ToggleDatesFilter";
import { AppList } from "components/list/AppList";
import { useGridUserDataGlobalFiltersContext } from "contexts/GridUserDataGlobalFiltersProvider";
// import { isExternalNotApproved } from "utils/checker/entity";
import { useUserSettingsContext } from "contexts/UserSettingsProvider";
import { envSettings } from "core/EnvSettings";
import { differenceInMinutes } from "date-fns";
import { format as dateFnsFormat } from "date-fns";
import React, { useCallback, useEffect, useMemo, useRef } from "react";
import {
	Button,
	EditButton,
	FunctionField,
	Loading,
	NumberField,
	ShowButton,
	TextField,
	useDataProvider,
	useGetList,
	useGetOne,
	useListContext,
	usePermissions,
	useRecordContext,
	useRedirect,
	useRefresh,
	useTranslate,
} from "react-admin";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useGetRedirectToDeviationCreate } from "utils/businessLogic/redirectToDeviationCreate";

import { TIME_FORMAT } from "../../../components/_helpers/dateTime";
import { Datagrid } from "../../../components/CustomizableDataGrid/";
import { OutgoingDocItemsPopup } from "../../../components/dialogs/OutgoingDocItemsPopup";
import { DraggableContextsWrapper } from "../../../components/DraggableDatagrid";
import ExternalOrderDetailsButton from "../../../components/ExternalOrderDetails";
import ChatMessageCountField from "../../../components/fields/ChatMessageCountField";
import { CountryISOCodeField } from "../../../components/fields/CountryISOCodeField";
import { CssRowFieldCellWrapper } from "../../../components/fields/CssFieldCellWrapper";
import CustomerField from "../../../components/fields/CustomerField";
import { DateFormatField } from "../../../components/fields/DateFormatField";
import { DeviationsLinkField } from "../../../components/fields/DeviationsLinkField";
import { TextEditableField } from "../../../components/fields/EditableField";
import { ButtonEditableCustomField } from "../../../components/fields/EditableField";
import { BooleanField, EqualField } from "../../../components/fields/EqualField";
import { FakeReferenceTextField } from "../../../components/fields/FakeReferenceTextField";
import { EditButtonField, ShowButtonField } from "../../../components/fields/LinkField";
import { LongTextField } from "../../../components/fields/LongTextField";
import { NoneOrValueField } from "../../../components/fields/NoOrValueField";
import { OrderServiceChipField } from "../../../components/fields/ObjectChipField";
import { OrderStatusField } from "../../../components/fields/OrderStatusField";
import { OSFCUserSelectField } from "../../../components/fields/OSFCUserSelect";
import { PlaceField } from "../../../components/fields/PlaceField";
import { PortField } from "../../../components/fields/PortField";
import { toPrice } from "../../../components/fields/PriceField";
import { PriorityField } from "../../../components/fields/PriorityField";
import { SelectEnumField } from "../../../components/fields/SelectEnumField";
import { TooltipTextField } from "../../../components/fields/TooltipTextField";
import TransDriverField from "../../../components/fields/TransDriverField";
import { YesNoField } from "../../../components/fields/YesNoField";
import { GridInput } from "../../../components/GridForm";
import { ForkliftIcon } from "../../../components/icons/ForkliftIcon";
import { PalletIconField } from "../../../components/icons/PalletIconField";
import { TimeInput, YesNoInput } from "../../../components/inputs";
import { PortInput } from "../../../components/inputs/PortInput";
import TerminalDatesInput from "../../../components/inputs/TerminalDatesInput";
import { ScrollingWrapper } from "../../../components/ScrollingWrapper";
import { SearchResultDocumentsRowExpand } from "../../../components/SearchResultRowExpand";
import GridUserDataProvider, {
	useGridUserDataContext,
} from "../../../contexts/GridUserDataProvider";
import { useOwnerCompanyDataContext } from "../../../contexts/OwnerCompanyDataProvider";
import { useTerminalsContext } from "../../../contexts/TerminalsProvider";
import {
	AppManagerRoles,
	CompanyManagerEmployeeRoles,
	CoolerType,
	OSFCUserRoles,
	OrderDocumentOutputType,
	OrderService,
	OrderServices,
	OrderStatus,
	OrderStatusCustomerEdit,
	OrderStatusDraftUnviewedColor,
	OrderStatusNotactive,
	TransporterRoles,
	UserRole,
	UserRoleByCompanyType,
	thirdAssigneeEligibleServices,
} from "../../../entities/";
import { FieldDependencies, HideableOrderField } from "../../../entities/HideableOrderField";
import { LabelSource } from "../../../entities/LabelSource";
import { LinkOrderType } from "../../../entities/LinkOrderType";
import { OutDocumenStatus } from "../../../entities/OutDocumentStatus";
import { CompPerm } from "../../../entities/Permission";
import { useTerminalFieldVisibility } from "../../../hooks/useTerminalFieldVisibility";
import { checkIsRankDisabled } from "../../../utils/checker/order";
import { plainNumber } from "../../../utils/constants";
import { getNowByTerminal, str2datetime } from "../../../utils/datetime";
import { isInArray, isNullUndEmpty } from "../../../utils/general";
import { useAsyncColumnsStorage } from "../../../utils/hooks/useAsyncColumnsStorage";
import { useExpandDefaultForAll } from "../../../utils/hooks/useExpandDefaultForAll";
import { useIsSearchMode } from "../../../utils/hooks/useIsSearchMode";
import { useOutDocStatuses } from "../../../utils/hooks/useOutDocStatuses";
import { isStorageModuleEnabled } from "../../../utils/storageModule";
import { validateArea } from "../../../utils/validation/order";
import { RankField } from "../components/RankField";
import { OrdersActions } from "./Actions";
import CustomBulkActionButtons from "./CustomBulkActionButtons";
import { HandleOnDragEndWrapper } from "./HandleOnDragEndWrapper";
import { OrdersFilter, filterDefaultValues } from "./ListFilters";
import { TotalPriceLabel } from "./TotalPriceLabel";

const defaultSort = { field: "id", order: "DESC" };

const BG_COLOR_WHITE = "#ffffff";
const BG_COLOR_GREEN = "#b7ff7d";
const BG_COLOR_DARKGREEN = "#008000";
const BG_COLOR_RED = "#ff8c8c";
const BG_COLOR_YELLOW = "#FFE600";
const BG_COLOR_DARKRED = "##C9211E";

const useStyles = makeStyles({
	list: {
		noResults: {
			backgroundColor: "red",
			padding: 100,
		},
		actions: {
			backgroundColor: "blue",
		},
	},
	expandIcon: {
		padding: "2px",
	},
});

const useCellStyles = makeStyles({
	cellGreen: {
		backgroundColor: BG_COLOR_GREEN, // green
	},
	cellRed: {
		backgroundColor: BG_COLOR_RED, // red
	},
	cellWhite: {
		backgroundColor: BG_COLOR_WHITE, // white
	},
	noPadding: {
		padding: "0",

		"&>span>button": {
			borderTopRightRadius: 0,
		},
	},
	noPaddingButton: {
		padding: "0",

		"&>span>button": {
			backgroundColor: BG_COLOR_WHITE,
			borderRadius: 3,
			border: "1px solid white",
			// outline: "1px solid white",
			minWidth: "auto",
		},
	},
	noPaddingButtonStart: {
		"&>span>button": {
			borderTopRightRadius: 0,
			borderBottomRightRadius: 0,
			borderRight: "none",
		},
	},
	noPaddingButtonEnd: {
		"&>span>button": {
			borderTopLeftRadius: 0,
			borderBottomLeftRadius: 0,
			borderLeft: "none",
		},
	},
	cellEtaTruck: {
		".order-cc-late &>span>button": {
			// backgroundColor: BG_COLOR_RED,
		},
		".order-car-detected-eta &>span>button": {
			// borderColor: BG_COLOR_DARKGREEN,
			backgroundColor: BG_COLOR_GREEN,
		},
	},
	cellEtdTruck: {
		".order-cc-late &>span>button": {
			// backgroundColor: BG_COLOR_RED,
		},
		".order-car-detected-etd &>span>button": {
			// borderColor: BG_COLOR_DARKGREEN,
			backgroundColor: BG_COLOR_GREEN,
		},
	},
	cellTime: {
		"&>span": {
			padding: "0 2px",
			border: "1px solid transparent",
			// outline: "1px solid transparent",
		},
		".order-cc-late &>span": {
			// backgroundColor: BG_COLOR_RED,
			cursor: "pointer",
		},
		".order-cc-late &>span .tt-icon": {
			padding: "0 6px",
			backgroundColor: BG_COLOR_YELLOW,
			color: BG_COLOR_DARKRED,
			fontWeight: "bold",
		},
	},
	cellEtaTime: {
		".order-car-detected-eta &>span": {
			// borderColor: BG_COLOR_DARKGREEN,
			outlineColor: "white",
			backgroundColor: BG_COLOR_GREEN + "!important",
		},
		".updated-eta-by-customer &>span": {
			// cursor: 'pointer',
			outlineColor: "white",
			backgroundColor: BG_COLOR_RED,
		},
		// '.updated-eta-by-customer &>span .tt-icon':{
		// 	padding: '0 6px',
		// 	backgroundColor: BG_COLOR_YELLOW,
		// 	color: BG_COLOR_DARKRED,
		// 	fontWeight: 'bold'
		// }
	},
	cellEtdTime: {
		".order-car-detected-etd &>span": {
			// borderColor: BG_COLOR_DARKGREEN,
			outlineColor: "white",
			backgroundColor: BG_COLOR_GREEN + "!important",
		},
		".updated-etd-by-customer &>span": {
			// cursor: 'pointer',
			outlineColor: "white",
			backgroundColor: BG_COLOR_RED,
		},
		// '.updated-etd-by-customer &>span .tt-icon':{
		// 	padding: '0 6px',
		// 	backgroundColor: BG_COLOR_YELLOW,
		// 	color: BG_COLOR_DARKRED,
		// 	fontWeight: 'bold'
		// }
	},
	// cellEtaTime: {
	// 	'.order-cc-late &>span': {
	// 		backgroundColor: BG_COLOR_RED,
	// 		color: BG_COLOR_GREEN,
	// 	},
	// },
	// cellEtdTime: {
	// 	'.order-cc-late &>span': {
	// 		backgroundColor: BG_COLOR_GREEN,
	// 		color: BG_COLOR_RED
	// 	},
	// },
});

const Label = ({ title, label }) => {
	return (
		<Tooltip title={title} placement="bottom">
			<div>{label}</div>
		</Tooltip>
	);
};

const prepareEtaArrived = (v) => ({
	port_in: v.port_in,
	eta_time: v.eta_time,
	eta_slot_time: v.eta_slot_time,
	is_eta_arrived_manual: true,
	status: OrderStatus.ONE_IN_TERMINAL,
});

const prepareEtdArrived = (v) => ({
	port_out: v.port_out,
	etd_time: v.etd_time,
	etd_slot_time: v.etd_slot_time,
	is_etd_arrived_manual: true,
	status: OrderStatus.ONE_IN_TERMINAL,
});

const getFilterDataArray = (rec) => {
	switch (rec["link_order_type"]) {
		case LinkOrderType.trip_number:
			return ["outgoing_trip_number", rec["outgoing_trip_number"]];
		case LinkOrderType.truck_id_and_time:
			return rec["outgoing_doc_type"] === OrderDocumentOutputType.unloading
				? ["eta_truck_id", rec["eta_truck_id"]]
				: ["etd_truck_id", rec["etd_truck_id"]];
		case LinkOrderType.truck_and_time:
			return rec["outgoing_doc_type"] === OrderDocumentOutputType.unloading
				? ["eta_truck", rec["eta_truck"]]
				: ["etd_truck", rec["etd_truck"]];
		case LinkOrderType.trailer_id_and_time:
			return rec["outgoing_doc_type"] === OrderDocumentOutputType.unloading
				? ["eta_trailer_id", rec["eta_trailer_id"]]
				: ["etd_trailer_id", rec["etd_trailer_id"]];
		case LinkOrderType.trailer_and_time:
			return rec["outgoing_doc_type"] === OrderDocumentOutputType.unloading
				? ["eta_trailer", rec["eta_trailer"]]
				: ["etd_trailer", rec["etd_trailer"]];
		case LinkOrderType.truck_join_and_time:
			return rec["outgoing_doc_type"] === OrderDocumentOutputType.unloading
				? rec["eta_truck"]
					? ["eta_truck", rec["eta_truck"]]
					: ["eta_truck_id", rec["eta_truck_id"]]
				: rec["etd_truck"]
				? ["etd_truck", rec["etd_truck"]]
				: ["etd_truck_id", rec["etd_truck_id"]];
		case LinkOrderType.trailer_join_and_time:
			return rec["outgoing_doc_type"] === OrderDocumentOutputType.unloading
				? rec["eta_trailer"]
					? ["eta_trailer", rec["eta_trailer"]]
					: ["eta_trailer_id", rec["eta_trailer_id"]]
				: rec["etd_trailer"]
				? ["etd_trailer", rec["etd_trailer"]]
				: ["etd_trailer_id", rec["etd_trailer_id"]];
		case LinkOrderType.none:
			return rec["outgoing_doc_type"] === OrderDocumentOutputType.unloading
				? ["eta_time", rec["eta_time"]]
				: ["etd_time", rec["etd_time"]];
		default:
			return [null, null];
	}
};

const TruckEditableConditionalField = ({ ...props }) => {
	const source = props.source;
	const record = props.record;

	const disallowRender =
		(record.service === OrderService.intoPlukkStorage &&
			source === "eta" &&
			record.eta_date == null) ||
		(record.service === OrderService.intoPlukkStorage &&
			source === "etd" &&
			record.etd_date == null) ||
		(record.service === OrderService.coldStorage && source === "etd");

	if (disallowRender) return null;

	return <ButtonEditableCustomField {...props} />;
};

const DocumentsButton = (props) => {
	const [isOpenedPopover, setIsOpenedPopover] = React.useState(false);
	const popoverAnchor = React.useRef(null);

	const openPopover = () => {
		setIsOpenedPopover(true);
	};

	const closePopover = () => {
		setIsOpenedPopover(false);
	};

	const [link_order_key, link_order_value] = getFilterDataArray(props.record);

	const data = {
		outDocType: props.record["outgoing_doc_type"],
		// outDocSrc: props.record["outgoing_doc_src"],
		outDocSrc: props.record["outgoing_doc_preview_src"],
		outDocItems: props.record["outgoing_doc_items_with_max_status"],
		suggested_area: props.record["suggested_area"],
		suggested_area_2: props.record["suggested_area_2"],
		outgoing_order_doc_status: props.record["outgoing_order_doc_status"],
		outDocStatuses: props.outDocStatuses,
		link_order_key: link_order_key,
		link_order_value: link_order_value,
		eta_date: props.record["eta_date"],
		eta_time: props.record["eta_time"],
		etd_date: props.record["etd_date"],
		etd_time: props.record["etd_time"],
	};

	return (
		<>
			<div ref={popoverAnchor} onMouseEnter={openPopover} onMouseLeave={closePopover}>
				<ShowButton
					to={`/${props.resource}/${props.record.id}/show/${props.pageIndex}`}
					icon={props.record.has_documents ? <DescriptionIcon /> : <SubjectIcon />}
					{...props}
				/>
			</div>
			{props.record.outgoing_order_doc_status > OutDocumenStatus.none ? (
				<OutgoingDocItemsPopup
					anchorEl={popoverAnchor}
					handlePopoverOpen={openPopover}
					handlePopoverClose={closePopover}
					isOpen={isOpenedPopover}
					data={data}
					permissions={props.permissions}
				/>
			) : null}
		</>
	);
};

const ActionButtonsField = ({
	isCompanyActive,
	isSearchMode,
	resource,
	basePath,
	record,
	outDocStatuses,
	comp_perm,
	permissions,
}) => {
	const outgoing_doc_style =
		outDocStatuses && record && record.has_out_documents
			? {
					backgroundColor:
						outDocStatuses[record.outgoing_order_doc_status] &&
						outDocStatuses[record.outgoing_order_doc_status].color,
					border: "1px solid #000000",
			  }
			: {};

	return (
		<Box display="flex" flexDirection="row" gap={2}>
			{/* {isExternalNotApproved(record.state) && record?.external_order_details ?  */}
			{record?.external_order_details ? (
				<ExternalOrderDetailsButton
					record={record}
					source="external_order_details"
					style={{ minWidth: "auto", ...outgoing_doc_style }}
				/>
			) : null}
			{record.has_documents || record.has_out_documents ? (
				<DocumentsButton
					label=""
					resource={resource}
					basePath={basePath}
					record={record}
					pageIndex={
						comp_perm & CompPerm.is_output_document && record.has_out_documents
							? "internal-documents"
							: "documents"
					}
					style={{ minWidth: "auto", ...outgoing_doc_style }}
					outDocStatuses={outDocStatuses}
					permissions={permissions}
				/>
			) : (
				<ShowButton
					label=""
					to={`/${resource}/${record.id}/show`}
					icon={<EditIcon />}
					style={{ minWidth: "auto", ...outgoing_doc_style }}
					resource={resource}
					basePath={basePath}
					record={record}
				/>
			)}
			{isSearchMode && (
				<Link to={`/${resource}/${record.id}/show`} target={"_blank"}>
					<Button style={{ minWidth: "auto", ...outgoing_doc_style }}>
						<VisibilityIcon />
					</Button>
				</Link>
			)}
		</Box>
	);
};

const GridFieldWithSelectionOnDoubleClick = ({
	isEqual = false,
	component,
	allowReplaceSource = false,
	...props
}) => {
	const listContext = useListContext();
	const refresh = useRefresh();
	const record = useRecordContext(props);

	const source = allowReplaceSource ? props.replaceRefSource : props.source;
	const handleOnDoubleClick = useCallback(
		(event) => {
			event.stopPropagation();
			const newSelectedIds = Object.values(listContext.data)
				.filter((row) => row[source] === record[source])
				.map((row) => row.id);

			if (
				newSelectedIds.length !== 0 &&
				!newSelectedIds.every((id) => listContext.selectedIds.includes(id))
			) {
				listContext.onSelect(newSelectedIds);
				refresh();
			}
		},
		[listContext.data, listContext.selectedIds, source]
	);

	const sharedProps = {
		style: { cursor: "pointer" },
		title: "Double click to select same records",
		onDoubleClick: handleOnDoubleClick,
	};

	return React.createElement(component, { ...props, ...sharedProps });
};

const useDraggableMode = () => {
	const { permissions } = usePermissions();
	const listParamsData = useSelector((state) =>
		state.admin.resources["orders"] ? state.admin.resources["orders"].list.params : {}
	);

	return (
		permissions &&
		(permissions.role === UserRole.osfc_manager ||
			permissions.role === UserRole.admin ||
			permissions.role === UserRole.app_manager) &&
		listParamsData.sort === "rank" &&
		listParamsData.order === "DESC"
	);
};

// const checkIfRankHidden = (filterValues) => filterValues &&
// 		filterValues['state'] === 'active' &&
// 		filterValues['terminal_id'] && Number.isInteger(filterValues['terminal_id'][0]) &&
// 		filterValues['eta_date|etd_date'] && filterValues['eta_date|etd_date'][0] === 'today'
// 	? {} : {rank:-1};

// Info: for better performance it would be better to calculate at backend side
const isOrderCCLate = (rec) => {
	if (
		rec["service"] === OrderService.reloadCarCar &&
		rec["eta_date"] &&
		rec["eta_time"] &&
		rec["etd_date"] &&
		rec["etd_time"]
	) {
		const diffMin = differenceInMinutes(
			str2datetime(rec["eta_date"], rec["eta_time"]),
			str2datetime(rec["etd_date"], rec["etd_time"])
		);
		return diffMin > 15;
	}
	return false;
};

const DutyManager = ({ terminals, currentFilters, translate }) =>
	terminals && !isNullUndEmpty(currentFilters.terminal_id) ? (
		<Box mt={2} ml={2} mb={2}>
			<Typography variant="body1" style={{ paddingLeft: 15 }}>
				{translate("tab.duty_manager.name")}:{" "}
				{terminals[currentFilters.terminal_id[0]]?.duty_manager_name ??
					translate("tab.duty_manager.no_manager")}
			</Typography>
		</Box>
	) : null;

const CustomFakeReferenceTextField = ({ refSource, replaceRefSource, ...rest }) => {
	return <FakeReferenceTextField {...rest} source={refSource} replaceSource={replaceRefSource} />;
};

const _OrdersList = ({ permissions, isDraft, fixedFilterValues, ...props }) => {
	const dataProvider = useDataProvider();
	const { filters: _currentFilters, sort: currentSort } = useGridUserDataContext();
	const currentFilters = { ..._currentFilters, ...fixedFilterValues };
	const { ownerCompanyData } = useOwnerCompanyDataContext();
	const redirect = useRedirect();
	const classes = useStyles();
	const cellClasses = useCellStyles();
	const aboveListRef = useRef(null);
	const translate = useTranslate();
	const t = (field) => translate(`resources.orders.fields.${field}`);
	const gridLabel = (field) => translate(`osfc.grid-label.${field}`);
	const columnsAsyncStorage = useAsyncColumnsStorage(
		isDraft ? "draft-orders-columns" : "orders-columns"
	);
	const isSearchMode = useIsSearchMode(currentFilters, props.resource);
	const refresh = useRefresh();
	const [isBulkOpen, setIsBulkOpen] = React.useState(false);
	// const isDraggableMode = useDraggableMode();
	const isDraggableMode = false;
	const { data: terminals } = useTerminalsContext();
	const { ids: _, data: statuses } = useGetList("order-statuses");
	const redirectToDeviationCreate = useGetRedirectToDeviationCreate();
	const isOSFCUser = permissions && OSFCUserRoles.has(permissions.role);
	const [customFields, setCustomFields] = React.useState([]);
	const { statusesById: outDocStatuses } = useOutDocStatuses();
	const { isFieldHidden } = useTerminalFieldVisibility(currentFilters?.terminal_id?.[0]);
	const listUsesStorageModule = isStorageModuleEnabled(terminals[currentFilters?.terminal_id?.[0]]);
	const listPlaceField = listUsesStorageModule ? "storage_place_id" : "area_id";

	const { ids: ___, data: rankPriorities } = useGetList(
		"rank-priorities",
		{ page: 0, perPage: -1 },
		{ field: "id", order: "ASC" }
	);
	// TODO: Load company settings one time when app is laoded (similar to the user settings)
	const priceCompanyId = isOSFCUser ? currentFilters?.company_id : permissions?.company_id;
	const { data: priceCompany } = useGetOne("customer-companies", priceCompanyId, {
		enabled: !!priceCompanyId,
	});
	useEffect(() => {
		if (permissions?.time_refresh_order) {
			const intervalId = setInterval(refresh, permissions.time_refresh_order * 1000);
			return () => clearInterval(intervalId);
		}
	}, [permissions]);

	const companyId = currentFilters?.company_id || permissions?.company_id;
	React.useEffect(() => {
		if (!companyId) {
			setCustomFields([]);
			return;
		}

		dataProvider
			.getList("custom-fields", {
				pagination: { page: 0, perPage: -1 },
				sort: { field: "id", order: "ASC" },
				filter: { company_id: companyId, is_show_on_grid: true },
			})
			.then(({ data }) => setCustomFields(data));
	}, [companyId]);

	useExpandDefaultForAll(props.resource);

	if (!permissions || currentFilters === undefined || !columnsAsyncStorage.isLoaded) {
		return <Loading loadingSecondary="" />;
	}

	const orderRowStyle = (record, index) => {
		if (record.status === OrderStatus.DRAFT) {
			// if (isExternalNotApproved(record.state)) {
			// 	return { backgroundColor: OrderExternalNotApprovedColor };
			// } else if (!record.is_viewed_draft) {
			if (!record.is_viewed_draft) {
				return { backgroundColor: OrderStatusDraftUnviewedColor };
			}
		}
		return { backgroundColor: statuses[record.status] && statuses[record.status].color };
	};

	const orderRowClass = (rec) => {
		const css = [];
		if (isOrderCCLate(rec)) {
			css.push("order-cc-late");
		}

		if (!OrderStatusNotactive.includes(rec.status)) {
			if (
				isInArray(
					[OrderService.reloadCarTerminalCar, OrderService.crossDock, OrderService.per],
					rec.service
				)
			) {
				if (
					rec.is_eta_arrived &&
					[
						OrderStatus.DRAFT,
						OrderStatus.BOOKED,
						OrderStatus.ONE_IN_TERMINAL,
						OrderStatus.LOADING_READY,
					].includes(rec.status)
				) {
					css.push("order-car-detected-eta");
				}
			} else {
				if (rec.is_eta_arrived) {
					css.push("order-car-detected-eta");
				}
			}

			if (rec.is_etd_arrived) {
				css.push("order-car-detected-etd");
			}
		}

		if (rec.is_eta_updated_by_customer) {
			css.push("updated-eta-by-customer");
		}
		if (rec.is_etd_updated_by_customer) {
			css.push("updated-etd-by-customer");
		}

		if (isCustomerAndTransporterCompany) {
			if (userCompanyId && userCompanyId !== rec["company_id"]) {
				if (userCompanyId === rec["eta_3rd_party"]) {
					css.push("order-as-trans-eta");
				}
				if (userCompanyId === rec["etd_3rd_party"]) {
					css.push("order-as-trans-etd");
				}
			}
		}
		return css;
	};

	const userCompanyId = permissions && permissions.company_id;
	const isCompanyActive = !permissions["company_is_blocked"];
	const isAppManager = permissions && isInArray(AppManagerRoles, permissions.role);
	const isRankVisible =
		isAppManager || (permissions && permissions.role === UserRole.osfc_employee);

	const isCustomerCompany =
		permissions &&
		(permissions.role === UserRole.customer_manager ||
			permissions.role === UserRole.customer_employee);
	const isCustomerAndTransporterManagerEmployee =
		permissions &&
		(permissions.role === UserRole.customer_and_transporter_manager ||
			permissions.role === UserRole.customer_and_transporter_employee);
	const isCustomerAndTransporterCompany =
		isCustomerAndTransporterManagerEmployee ||
		permissions.role === UserRole.customer_and_transporter_driver;
	const isCustomerManagerOrEmployee =
		permissions && CompanyManagerEmployeeRoles.indexOf(permissions.role) !== -1;

	const isDriver =
		permissions &&
		(permissions.role === UserRole.customer_and_transporter_driver ||
			permissions.role === UserRole.transporter_driver);

	const isNot3rdPartyRole =
		UserRoleByCompanyType.transporter_all_roles.indexOf(permissions.role) === -1;
	const isDeviationUser = !isInArray(TransporterRoles, permissions.role);
	const canMultipleChanges = isOSFCUser || isCustomerManagerOrEmployee;
	const allowDraftMultipleDelete =
		isDraft &&
		(isOSFCUser ||
			isCustomerCompany ||
			(isCustomerAndTransporterManagerEmployee && currentFilters?.order_type === "customer"));

	const exposedColumns = ["rank"];

	const msgMsgNotChangeTruckArrived = translate(
		"resources.orders.messages.warn.not-change-truck-arrived"
	);
	const msgSystemWillSetNow = translate("resources.orders.messages.warn.system-will-set-now");

	const currency = priceCompany?.currency ?? ownerCompanyData.main_currency;
	const toPriceFormatter = (value) => toPrice(value, currency);

	return (
		<div ref={aboveListRef}>
			<DraggableContextsWrapper isDraggableDefault={isDraggableMode}>
				<AppList
					{...props}
					perPage={50}
					rowsPerPageOptions={[25, 50, 100]}
					empty={false}
					classes={classes.list}
					exporter={false}
					bulkActionButtons={
						canMultipleChanges &&
						isBulkOpen && (
							<CustomBulkActionButtons allowDraftMultipleDelete={allowDraftMultipleDelete} />
						)
					}
					filters={
						<OrdersFilter
							hasCompanyFilter={isOSFCUser}
							hasOrderTypeFilter={isCustomerAndTransporterCompany}
							isOnlyDates={isDriver}
							isSearchMode={isSearchMode}
							isDraft={isDraft}
							userCompanyId={userCompanyId}
							customFields={customFields}
							currentFilters={currentFilters}
						/>
					}
					filter={currentFilters}
					filterDefaultValues={currentFilters}
					sort={currentSort}
					hasCreate={props.hasCreate && isCompanyActive}
					actions={<OrdersActions isDraft={isDraft} />}
				>
					<HandleOnDragEndWrapper>
						<ScrollingWrapper>
							<CustomFieldDatagridWrapper permissions={permissions} customFields={customFields}>
								<Datagrid
									rowDoubleClick={isDraft ? "edit" : undefined}
									rowStyle={orderRowStyle}
									classes={{ expandIcon: classes.expandIcon }}
									storage={columnsAsyncStorage}
									isRowExpandable={() => isSearchMode}
									expand={
										isSearchMode ? (
											<SearchResultDocumentsRowExpand replaceResource="orders" />
										) : (
											false
										)
									}
									expandIconCell={{ padding: "2px" }}
									canMultipleChanges={canMultipleChanges}
									isBulkOpen={isBulkOpen}
									setIsBulkOpen={setIsBulkOpen}
									exposedColumns={exposedColumns}
									useDragAndDropComponents={isDraggableMode}
									TopComponent={
										<DutyManager
											terminals={terminals}
											currentFilters={currentFilters}
											translate={translate}
										/>
									}
									// getHiddenColumns={checkIfRankHidden}
									permissions={permissions}
									reorderingSupport={true}
								>
									<CssRowFieldCellWrapper cssFn={orderRowClass} />
									<ActionButtonsField
										isCompanyActive={isCompanyActive}
										isSearchMode={isSearchMode}
										outDocStatuses={outDocStatuses}
										comp_perm={permissions.comp_perm}
										permissions={permissions}
									/>

									<ChatMessageCountField
										source="message_count"
										label=""
										reorder_name="Messages"
										sortable={false}
									/>

									{!isDraft && isDeviationUser && (
										<DeviationsLinkField label="" reorder_name="Deviations" sortable={false} />
									)}

									<PalletIconField
										icon={ForkliftIcon}
										tooltipKey="tab.pallets.icons.high_level_pallet"
										iconStyle={{ color: "red" }}
										isVisible={(record) => !!record?.is_exists_high_level_pallets}
										label=""
									/>

									{!isDraft && <TextField source="id" sortBy="order_id" label={t("id")} />}

									{(isOSFCUser || isCustomerAndTransporterCompany) && (
										<CustomerField
											label={t("company_id")}
											source="company_id"
											formatLabel={(record) => record["customer_name"]}
										/>
									)}
									<PriorityField
										source="priority"
										label={<Label title={t("priority")} label={gridLabel("priority")} />}
										sortable={false}
									/>
									{/* {isAppManager ? <RankField editable={isAppManager}
										 		source={"rank"}
										 		editLabel={translate("resources.orders.fields.rank_edit_label")}
												EditComponent={YesNoInput}
												checkIsDisabled={checkIsRankDisabled}
												rankPriorities={rankPriorities}
												// validate={validateRankField}
												format={val=> val === 'M' ? true : val===null || val===undefined ? false : typeof val === 'string' ? false : true }
												parse={val=> val === true ? 0 : null}
												{...props}
										/>
										: null} */}
									{isRankVisible && !isDraft ? (
										<RankField
											editable={isRankVisible}
											source="rank"
											label={<Label title={t("rank_tooltip")} label={t("rank")} />}
											editLabel={translate("resources.orders.fields.rank_edit_label")}
											EditComponent={YesNoInput}
											checkIsDisabled={checkIsRankDisabled}
											rankPriorities={rankPriorities}
											formatField={(val) => (val ? val : val === 0 ? "M" : null)}
										/>
									) : null}
									<FunctionField
										source="reference"
										label={t("reference")}
										render={(record) => (
											<EditButtonField
												source="reference"
												to={`/orders/${record.id}/show`}
												record={record}
												disabled={!isCompanyActive}
											/>
										)}
									/>
									{!isDraft ? (
										<OrderStatusField
											source="status"
											optimized={true}
											editable={
												isAppManager
													? true
													: isCustomerCompany
													? (rec) => OrderStatusCustomerEdit.indexOf(rec["status"]) !== -1
													: isCustomerAndTransporterCompany && !isDriver
													? (rec) =>
															OrderStatusCustomerEdit.indexOf(rec["status"]) !== -1 &&
															userCompanyId === rec["company_id"]
													: false
											}
											additionalParams={["set_order_completed"]}
											permissions={permissions}
										/>
									) : null}
									<OrderServiceChipField
										label={t("service")}
										source="service"
										object={OrderServices}
										titleKey="short_name"
										tooltipKey="full_name"
									/>
									<FakeReferenceTextField
										source="terminal_id"
										replaceSource="terminal_name"
										label={t("terminal")}
									/>
									<TextField source="et_date_union" label={t("et_date_union")} />

									<DateFormatField
										source="eta_date"
										headerClassName={cellClasses.cellGreen}
										label={t("eta_date")}
									/>

									<TooltipTextField
										label={t("eta_time")}
										source="eta_time"
										headerClassName={cellClasses.cellGreen}
										cellClassName={cellClasses.cellTime + " " + cellClasses.cellEtaTime}
										ttFn={(rec) =>
											isOrderCCLate(rec)
												? translate("resources.orders.messages.is-order-cc-late")
												: false
										}
									/>
									{/* <TextField source="eta_time" headerClassName={cellClasses.cellGreen} cellClassName={cellClasses.cellEtaTime} /> */}

									<TextField
										source="eta_slot_time"
										headerClassName={cellClasses.cellGreen}
										label={t("eta_slot_time")}
									/>

									<PortField
										label={t("port_in")}
										source="port_in"
										headerClassName={cellClasses.cellGreen}
										isOSFCUser={isOSFCUser}
										permissions={permissions}
									/>
									{!isFieldHidden(HideableOrderField.ETA_3RD_PARTY) ? (
										<CustomerField
											label={t("eta_3rd_party")}
											source="eta_3rd_party"
											formatLabel={(record) => record["eta_3rd_party_name"]}
											headerClassName={cellClasses.cellGreen}
										/>
									) : null}
									{!isFieldHidden(HideableOrderField.ETA_4TH_PARTY) ? (
										<CustomerField
											label={t("eta_4th_party")}
											source="eta_4th_party"
											formatLabel={(record) => record["eta_4th_party_name"]}
											headerClassName={cellClasses.cellGreen}
										/>
									) : null}
									{isNot3rdPartyRole && !isFieldHidden(HideableOrderField.ETA_SHOW_DOC_FOR_TRANS) ? (
										<YesNoField
											source="eta_show_doc_for_trans"
											headerClassName={cellClasses.cellGreen}
											label={t("eta_show_doc")}
										/>
									) : null}

									{isCustomerAndTransporterCompany && !isFieldHidden(HideableOrderField.ETA_DRIVER) && (
										<TransDriverField
											source="eta_driver"
											refSource="eta_driver_id"
											prefix="eta"
											formatLabel={(record) => record["eta_driver_name"]}
											headerClassName={cellClasses.cellGreen}
										/>
									)}

									{!isFieldHidden(HideableOrderField.ETA_TRUCK) &&
										(isAppManager && isBulkOpen ? (
											<GridFieldWithSelectionOnDoubleClick
												component={CustomFakeReferenceTextField}
												source="eta_truck"
												refSource="eta_truck_id"
												replaceRefSource="eta_truck_name"
												headerClassName={cellClasses.cellGreen}
												allowReplaceSource={true}
											/>
										) : (
											<CustomFakeReferenceTextField
												source="eta_truck"
												refSource="eta_truck_id"
												replaceRefSource="eta_truck_name"
												headerClassName={cellClasses.cellGreen}
											/>
										))}

									{!isFieldHidden(HideableOrderField.ETA_TRAILER) &&
										(isAppManager && isBulkOpen ? (
											<GridFieldWithSelectionOnDoubleClick
												component={CustomFakeReferenceTextField}
												source="eta_trailer"
												refSource="eta_trailer_id"
												replaceRefSource="eta_trailer_name"
												headerClassName={cellClasses.cellGreen}
												allowReplaceSource={true}
											/>
										) : (
											<CustomFakeReferenceTextField
												source="eta_trailer"
												refSource="eta_trailer_id"
												replaceRefSource="eta_trailer_name"
												headerClassName={cellClasses.cellGreen}
											/>
										))}
									{!isFieldHidden(HideableOrderField.PLACE_FROM) ? (
										<LongTextField
											source="place_from"
											headerClassName={cellClasses.cellGreen}
											label={t("place_from")}
										/>
									) : null}
									{!isFieldHidden(HideableOrderField.PLACE_FROM_COUNTRY_CODE) ? (
										<CountryISOCodeField
											source="place_from_country_code"
											headerClassName={cellClasses.cellGreen}
											label={t("place_from_country_code")}
										/>
									) : null}
									{!isFieldHidden("eta_external_terminal_id") ? (
										<FakeReferenceTextField
											source="eta_external_terminal_id"
											replaceSource="eta_external_terminal_name"
											label={t("eta_external_terminal_id")}
											headerClassName={cellClasses.cellGreen}
										/>
									) : null}
									{!isFieldHidden(HideableOrderField.INCOMING_TRIP_NUMBER) ? (
										<TextField
											source="incoming_trip_number"
											label={t("incoming_trip_number")}
											headerClassName={cellClasses.cellGreen}
										/>
									) : null}
									{!isFieldHidden(HideableOrderField.UNLOADING_SEQUENCE) ? (
										<NumberField
											{...plainNumber}
											source="unloading_sequence"
											label={t("unloading_sequence")}
											headerClassName={cellClasses.cellGreen}
										/>
									) : null}
									{!isFieldHidden(HideableOrderField.COMMODITY_ID) ? (
										<FakeReferenceTextField
											source="commodity_id"
											replaceSource="commodity_name"
											headerClassName={cellClasses.cellGreen}
										/>
									) : null}
									{!isFieldHidden(HideableOrderField.COOLER_TYPE_ID) ? (
										<EqualField
											source="cooler_type_id"
											to={CoolerType.freezer}
											label={<Label title={t("cooler_type_id")} label={gridLabel("cooler_type_id")} />}
											sortable={false}
											headerClassName={cellClasses.cellGreen}
										/>
									) : null}
									{!isFieldHidden(HideableOrderField.SEAL) ? (
										<BooleanField
											source="seal"
											label={<Label title={t("seal")} label={gridLabel("seal")} />}
											sortable={false}
											headerClassName={cellClasses.cellGreen}
										/>
									) : null}
									{!isFieldHidden(HideableOrderField.PALLETS) ? (
										<NumberField
											{...plainNumber}
											source="pallets"
											label={t("pallets")}
											headerClassName={cellClasses.cellGreen}
										/>
									) : null}
									{!isFieldHidden(HideableOrderField.BOXES) ? (
										<NumberField
											{...plainNumber}
											source="boxes"
											label={t("boxes")}
											headerClassName={cellClasses.cellGreen}
										/>
									) : null}
									{!isFieldHidden(HideableOrderField.KILOS) ? (
										<NumberField
											{...plainNumber}
											source="kilos"
											label={t("kilos")}
											headerClassName={cellClasses.cellGreen}
										/>
									) : null}
									{/* <TextField source="assignee_1" headerClassName={cellClasses.cellGreen} /> */}
									{isOSFCUser && !isFieldHidden(HideableOrderField.ASSIGNEE_1) && (
										<OSFCUserSelectField
											source="assignee_1"
											visibleSource="assignee_1_name"
											headerClassName={cellClasses.cellGreen}
											permissions={permissions}
										/>
									)}

									{isOSFCUser && (
										<TruckEditableConditionalField
											label={t("eta")}
											source="eta"
											title={<ArrivedIcon style={{ color: "#27ae60" }} fontSize="small" />}
											headerClassName={cellClasses.cellGreen}
											cellClassName={
												cellClasses.noPaddingButton +
												" " +
												cellClasses.noPaddingButtonStart +
												" " +
												cellClasses.cellEtaTruck
											}
											btnLabel={translate("osfc.buttons.truck_arrived")}
											prepareValues={prepareEtaArrived}
											updateType="updatePartial"
											moreFields={["terminal_id", "is_eta_arrived"]}
										>
											<FunctionField
												source="eta_time"
												render={(record) => {
													const props = record["is_eta_arrived"]
														? {
																source: "eta_time",
																title: msgMsgNotChangeTruckArrived,
														  }
														: {
																source: "eta_time_now",
																defaultValue: dateFnsFormat(
																	getNowByTerminal(terminals[record.terminal_id]),
																	TIME_FORMAT
																),
																title: msgSystemWillSetNow,
														  };
													return (
														<GridInput xs={12}>
															<TerminalDatesInput
																component={TimeInput}
																margin="dense"
																label="resources.orders.fields.eta_time"
																disabled
																{...props}
															/>
														</GridInput>
													);
												}}
											/>
											<GridInput xs={12}>
												<TerminalDatesInput
													component={TimeInput}
													margin="dense"
													label="resources.orders.fields.eta_slot_time"
													source="eta_slot_time"
												/>
											</GridInput>
											<FunctionField
												source="port_in"
												render={(record) => (
													<GridInput
														xs={12}
														component={PortInput}
														label="resources.orders.fields.port_in"
														source="port_in"
														filter={{ terminal_id: [record.terminal_id] }}
													/>
												)}
											/>
										</TruckEditableConditionalField>
									)}
									{isOSFCUser && (
										<TruckEditableConditionalField
											label={t("etd")}
											source="etd"
											title={<ArrivedIcon style={{ color: "#e74c3c" }} fontSize="small" />}
											headerClassName={cellClasses.cellRed}
											btnLabel={translate("osfc.buttons.truck_arrived")}
											cellClassName={
												cellClasses.noPaddingButton +
												" " +
												cellClasses.noPaddingButtonEnd +
												" " +
												cellClasses.cellEtdTruck
											}
											prepareValues={prepareEtdArrived}
											updateType="updatePartial"
											moreFields={["terminal_id", "is_etd_arrived"]}
										>
											<FunctionField
												source="etd_time"
												render={(record) => {
													const props = record["is_etd_arrived"]
														? {
																source: "etd_time",
																title: msgMsgNotChangeTruckArrived,
														  }
														: {
																source: "etd_time_now",
																defaultValue: dateFnsFormat(
																	getNowByTerminal(terminals[record.terminal_id]),
																	TIME_FORMAT
																),
																title: msgSystemWillSetNow,
														  };
													return (
														<GridInput xs={12}>
															<TerminalDatesInput
																component={TimeInput}
																margin="dense"
																label="resources.orders.fields.etd_time"
																source="etd_time"
																disabled
																{...props}
															/>
														</GridInput>
													);
												}}
											/>
											<GridInput xs={12}>
												<TerminalDatesInput
													component={TimeInput}
													margin="dense"
													label="resources.orders.fields.etd_slot_time"
													source="etd_slot_time"
												/>
											</GridInput>
											<FunctionField
												source="port_out"
												render={(record) => (
													<GridInput
														xs={12}
														component={PortInput}
														label="resources.orders.fields.port_out"
														source="port_out"
														filter={{ terminal_id: [record.terminal_id] }}
													/>
												)}
											/>
										</TruckEditableConditionalField>
									)}

									<DateFormatField
										source="etd_date"
										headerClassName={cellClasses.cellRed}
										label={t("etd_date")}
									/>

									<TooltipTextField
										label={t("etd_time")}
										source="etd_time"
										headerClassName={cellClasses.cellRed}
										cellClassName={cellClasses.cellTime + " " + cellClasses.cellEtdTime}
										ttFn={(rec) =>
											isOrderCCLate(rec)
												? translate("resources.orders.messages.is-order-cc-late")
												: false
										}
									/>
									{/* <TextField source="etd_time" headerClassName={cellClasses.cellRed} cellClassName={cellClasses.cellEtdTime} /> */}

									<TextField
										source="etd_slot_time"
										headerClassName={cellClasses.cellRed}
										label={t("etd_slot_time")}
									/>

									<PortField
										label={t("port_out")}
										source="port_out"
										headerClassName={cellClasses.cellRed}
										isOSFCUser={isOSFCUser}
										permissions={permissions}
									/>
									<PortField
										label={t("optimal_port_out")}
										source="optimal_port_out"
										headerClassName={cellClasses.cellRed}
										isOSFCUser={isOSFCUser}
										permissions={permissions}
										editable={false}
									/>
									{!isFieldHidden(HideableOrderField.ETD_3RD_PARTY) ? (
										<CustomerField
											label={t("etd_3rd_party")}
											source="etd_3rd_party"
											formatLabel={(record) => record["etd_3rd_party_name"]}
											headerClassName={cellClasses.cellRed}
										/>
									) : null}
									{!isFieldHidden(HideableOrderField.ETD_4TH_PARTY) ? (
										<CustomerField
											label={t("etd_4th_party")}
											source="etd_4th_party"
											formatLabel={(record) => record["etd_4th_party_name"]}
											headerClassName={cellClasses.cellRed}
										/>
									) : null}
									{isNot3rdPartyRole && !isFieldHidden(HideableOrderField.ETD_SHOW_DOC_FOR_TRANS) ? (
										<YesNoField
											label={t("etd_show_doc")}
											source="etd_show_doc_for_trans"
											headerClassName={cellClasses.cellRed}
										/>
									) : null}

									{isCustomerAndTransporterCompany && !isFieldHidden(HideableOrderField.ETD_DRIVER) && (
										<TransDriverField
											label={t("etd_driver")}
											source="etd_driver"
											refSource="etd_driver_id"
											prefix="etd"
											formatLabel={(record) => record["etd_driver_name"]}
											headerClassName={cellClasses.cellRed}
										/>
									)}

									{!isFieldHidden(HideableOrderField.ETD_TRUCK) &&
										(isAppManager && isBulkOpen ? (
											<GridFieldWithSelectionOnDoubleClick
												component={CustomFakeReferenceTextField}
												source="etd_truck"
												refSource="etd_truck_id"
												replaceRefSource="etd_truck_name"
												headerClassName={cellClasses.cellRed}
												allowReplaceSource={true}
											/>
										) : (
											<CustomFakeReferenceTextField
												source="etd_truck"
												refSource="etd_truck_id"
												replaceRefSource="etd_truck_name"
												headerClassName={cellClasses.cellRed}
											/>
										))}

									{!isFieldHidden(HideableOrderField.ETD_TRAILER) &&
										(isAppManager && isBulkOpen ? (
											<GridFieldWithSelectionOnDoubleClick
												component={CustomFakeReferenceTextField}
												source="etd_trailer"
												refSource="etd_trailer_id"
												replaceRefSource="etd_trailer_name"
												headerClassName={cellClasses.cellRed}
												allowReplaceSource={true}
											/>
										) : (
											<CustomFakeReferenceTextField
												source="etd_trailer"
												refSource="etd_trailer_id"
												replaceRefSource="etd_trailer_name"
												headerClassName={cellClasses.cellRed}
											/>
										))}

									{!isFieldHidden(HideableOrderField.PLACE_TO) ? (
										<LongTextField
											source="place_to"
											headerClassName={cellClasses.cellRed}
											label={t("place_to")}
										/>
									) : null}
									{!isFieldHidden(HideableOrderField.PLACE_TO_COUNTRY_CODE) ? (
										<CountryISOCodeField
											source="place_to_country_code"
											headerClassName={cellClasses.cellRed}
											label={t("place_to_country_code")}
										/>
									) : null}
									{!isFieldHidden("outgoing_trip_number") ? (
										isAppManager && isBulkOpen ? (
											<GridFieldWithSelectionOnDoubleClick
												component={TextField}
												source="outgoing_trip_number"
												label={t("outgoing_trip_number")}
												headerClassName={cellClasses.cellRed}
											/>
										) : (
											<TextField
												source="outgoing_trip_number"
												label={t("outgoing_trip_number")}
												headerClassName={cellClasses.cellRed}
											/>
										)
									) : null}
									{!isFieldHidden("loading_sequence") ? (
										<NumberField
											{...plainNumber}
											source="loading_sequence"
											label={t("loading_sequence")}
											headerClassName={cellClasses.cellRed}
										/>
									) : null}
									{!isFieldHidden("etd_external_terminal_id") ? (
										<FakeReferenceTextField
											source="etd_external_terminal_id"
											replaceSource="etd_external_terminal_name"
											label={t("etd_external_terminal_id")}
											headerClassName={cellClasses.cellRed}
										/>
									) : null}
									{!isFieldHidden(HideableOrderField.IS_DOC_FOR_NFSA) && (
										<YesNoField
											source="is_doc_for_nfsa"
											label={t("is_doc_for_nfsa")}
											headerClassName={cellClasses.cellRed}
										/>
									)}
									<FunctionField
										label={t(listPlaceField)}
										source={listPlaceField}
										headerClassName={cellClasses.cellRed}
										render={(record) => (
											<PlaceField
												record={record}
												isOSFCUser={isOSFCUser}
												permissions={permissions}
												resource={props.resource}
												basePath={props.basePath}
												validate={(value, _) => validateArea(value, record)}
											/>
										)}
									/>
									{isOSFCUser && !listUsesStorageModule && !isFieldHidden(HideableOrderField.IS_AREA_BLOCKED) ? (
										<YesNoField
											source="is_area_blocked"
											label={t("is_area_blocked")}
											headerClassName={cellClasses.cellRed}
										/>
									) : null}
									{!isFieldHidden(HideableOrderField.PLUMB) ? (
										<BooleanField
											source="plumb"
											label={<Label title={t("plumb")} label={gridLabel("plumb")} />}
											sortable={false}
											headerClassName={cellClasses.cellRed}
										/>
									) : null}
									{!isFieldHidden(HideableOrderField.PRINTED_DOC) && (
										<NoneOrValueField
											source="printed_doc"
											label={<Label title={t("printed_doc")} label={gridLabel("printed_doc")} />}
											sortable={false}
											headerClassName={cellClasses.cellRed}
										/>
									)}
									{!isFieldHidden(HideableOrderField.LABEL) ? (
										<TextField
											source="label"
											label={t("label")}
											headerClassName={cellClasses.cellRed}
										/>
									) : null}
									{!isFieldHidden(HideableOrderField.LABEL_SOURCE) ? (
										<SelectEnumField
											label={t("label_source")}
											source="label_source"
											enumName="label_source"
											enumObj={LabelSource}
											headerClassName={cellClasses.cellRed}
										/>
									) : null}
									{isOSFCUser && !isFieldHidden(HideableOrderField.ASSIGNEE_2) && (
										<OSFCUserSelectField
											source="assignee_2"
											visibleSource="assignee_2_name"
											headerClassName={cellClasses.cellRed}
											permissions={permissions}
										/>
									)}
									{isOSFCUser && !isFieldHidden(HideableOrderField.ASSIGNEE_3) && (
										<OSFCUserSelectField
											source="assignee_3"
											visibleSource="assignee_3_name"
											permissions={permissions}
											editable={(record) => thirdAssigneeEligibleServices.includes(record.service)}
										/>
									)}
									<ShowButtonField
										textAlign="right"
										source="total_price"
										label={
											isAppManager ? (
												<TotalPriceLabel source="total_price" resource={props.resource} />
											) : (
												<Label title={t("total_price")} label={t("total_price")} />
											)
										}
										formatter={toPriceFormatter}
										sortable={false}
										tabPath="general"
									/>
									<LongTextField source="notes" sortable={false} label={t("notes")} />
									{listUsesStorageModule && (
										<YesNoField label={t("is_reefer")} source="is_reefer" sortable={false} />
									)}
									<LongTextField
										source="internal_notes"
										label={t("internal_notes")}
										sortable={false}
									/>
								</Datagrid>
							</CustomFieldDatagridWrapper>
						</ScrollingWrapper>
					</HandleOnDragEndWrapper>
				</AppList>
			</DraggableContextsWrapper>
		</div>
	);
};

export const OrdersList = (_props) => {
	const { data: userSettings } = useUserSettingsContext();
	const { data: globalFilters = {} } = useGridUserDataGlobalFiltersContext();

	if (!(_props.permissions && userSettings)) return null;

	const props = { ..._props };
	const fixedFilterValues = { ...globalFilters };

	const isDraft = props.location.pathname.indexOf("draft-orders") !== -1;
	if (isDraft) {
		props.title = "resources.draft-orders.name";
		fixedFilterValues.draft_orders = true;
		fixedFilterValues["named_eta_etd_datetime"] = [ToggleDatesEnum.ALL];
	}

	return (
		<GridUserDataProvider
			resource={props.resource}
			filterDefaultValues={filterDefaultValues}
			sortDefaultValues={defaultSort}
		>
			<_OrdersList {...props} fixedFilterValues={fixedFilterValues} isDraft={isDraft} />
		</GridUserDataProvider>
	);
};
